import $ from '../lib/jquery';

import { Component } from '../core/component';

export class Iframe extends Component {
    selector = '.js-iframe';

    init() {
        this.$elements.each((index, element) => {
            const $element = $(element);
            const $iframe = $element.find('iframe');

            if ($iframe.attr('title')) return;

            $iframe.attr('title', $element.data('title'));
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/Iframe.js